export default {
    'Brown': {
        fontFamily: 'Brown',
    }
};